import styled from "styled-components";

export const Dialog = styled.dialog`
  max-height: 100vh;
  max-height: 100svh;
  height: 100vh;
  height: 100svh;
  max-width: 100%;
  width: 100%;
  border: none;
  background: ${({ theme }) => theme.palette.greyscale.grey800};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px 48px;
  height: 100%;
`;

export const CloseShareWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.primary.blue50};
  font-family: "Inter", sans-serif;
  font-size: ${16 / 16}rem;
`;

const IconTextWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const CloseIconTextWrapper = styled(IconTextWrapper)`
  font-weight: 700;
  margin-right: auto;
  gap: 16px;

  & svg {
    border: 1px solid currentColor;
    border-radius: 8px;
    padding: 8px;
    width: ${32 / 16}rem;
    height: ${32 / 16}rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${24 / 16}rem;
    gap: 24px;
    & svg {
      border: 1px solid currentColor;
      border-radius: 8px;
      padding: 12px;
      width: ${40 / 16}rem;
      height: ${40 / 16}rem;
    }
  }
`;

export const ShareLink = styled.a`
  color: white;
`;

export const ShareIconTextWrapper = styled(IconTextWrapper)`
  font-weight: 500;
  gap: 8px;

  & svg {
    width: ${24 / 16}rem;
    height: ${24 / 16}rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${20 / 16}rem;
  }
`;
export const GalleryWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  margin-top: 12px;

  & .image-gallery-icon {
    filter: none;
  }
  & .image-gallery-svg {
    background-color: white;
    opacity: 0.9;
    width: ${48 / 16}rem !important;
    height: ${48 / 16}rem !important;
    border-radius: 50%;
    padding: 8px;

    & polyline {
      color: ${({ theme }) => theme.palette.secondary.orange500};
    }
  }
  .image-gallery-image {
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      max-height: 560px !important;
    }
  }

  & .image-gallery-bullet {
    background-color: white;
    opacity: 0.45;
    box-shadow: none;
    &.active {
      opacity: 1;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin-top: 48px;
  }
`;

export const IndexText = styled.p`
  font-size: ${16 / 16}rem;
  font-weight: 600;
  text-align: center;
  color: white;
  margin-top: 24px;
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${24 / 16}rem;
  }
`;

export const SlideWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const AIBadge = styled.div`
  position: absolute;
  top: 16px;
  left: 16px;
  background: rgba(0,0,0,0.75);
  color: white;
  font-size: 14px;
  font-weight: 600;
  padding: 12px 10px;
  border-radius: 8px;
  backdrop-filter: blur(4px);
  z-index: 2;
`;
